import React, { useState, useEffect } from "react";
import { useHistory, useParams, useLocation } from "react-router-dom";
import { Row, Col, Card, CardBody, Form, Spinner, Button } from "reactstrap";
import { ToastContainer, toast } from "react-toastify";
import {
  putRequestForm,
  postRequest,
  postRequestForm,
} from "components/Common/Utils.js";
import Lightbox from "react-image-lightbox";
import ProductModal from "components/Modal/ProductModal";
import UserListModal from "components/Modal/UserListModal";


export default function NotificationUpdate() {

  const location = useLocation();
  
  const state = location.state?.row;
  const [productId, setProductId] = useState({});
  const [previewImage, setPreviewImage] = useState("");
  const [openLightbox, setOpenLightBox] = React.useState(false);
  const [loading, setLoading] = useState(false);
  const [isFileSelect, setIsFileSelect] = useState(false);
  const [veriFiedDocument, setveriFiedDocument] = useState([{ documentImage: "" }]);
  const [model, setModel] = useState(false);
  const [usermodel, setUserModel] = useState(false);
  const [selectedUserData, setSelectedUserData] = useState([]);
  const [userReturnChecked, setUserReturnChecked] = useState([]);
  const [viewMode, setViewMode] = useState(false);


  const [formValues, setFormValues] = useState({
    title: '',
    description: '',
    date: '',
    time: '',
    typeId : '',
    image: '',
    scheduled: '',
    targetUser: '',
    type: '',
    users: [],
    targetUser : '',
    notificationId : ''
  });

  
  useEffect(() => {
    console.log(location.state);
    const scheduledDateTime = location.state?.row.scheduledDateTime || '';
    const date = scheduledDateTime ? scheduledDateTime.slice(0, 10) : '';
    const time = scheduledDateTime ? scheduledDateTime.slice(11, 16) : '';
    setFormValues(location.state?.row);
    setFormValues((prev) => ({
      ...prev,
      date : date || '',
      time : time || '',
    }));
    setSelectedUserData(location.state?.row?.users);
    setViewMode(location.state?.viewMode);
    setProductId(location.state?.row?.productDetails?.[0]);
  }, [location.state?.row]);

  const handleChange = (name, value) => {
    setFormValues({ ...formValues, [name]: value });
  };

  const updateDocument = (key, file) => {
    setIsFileSelect(true);
    const isImage = file && file.type.startsWith("image/");
    const previewUrl = isImage ? URL.createObjectURL(file) : null;
    const updatedDocuments = veriFiedDocument.map((doc) => {
      return { 
        ...doc, 
        [key]: file, 
        previewUrl: previewUrl,
      };
    });
    setveriFiedDocument(updatedDocuments);
  };
  
  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!formValues.title) {
      toast.warn("Title is required.");
      return; // Prevent form submission
    }
    if (!formValues.description) {
      toast.warn("Description is required.");
      return; // Prevent form submission
    }
    if (!formValues.scheduled === 'true') {
      toast.warn("Scheduled date is required.");
      return; // Prevent form submission
    }
    if (!formValues.type) {
      toast.warn("Type is required.");
      return; // Prevent form submission
    }
    if (!formValues.targetUser) {
      toast.warn("Target User is required.");
      return; // Prevent form submission
    }

    let documentImage = '';
    if (isFileSelect) {
      if (veriFiedDocument?.[0]?.doc) {
        const selectedImage = new FormData();
        selectedImage.append("image", veriFiedDocument[0].doc);
        const selectedImageUrl = await postRequestForm("image/img/upload", selectedImage);
        documentImage = selectedImageUrl?.data?.url || '';
      }
    }
    let formValue = formValues;
    formValue.image = documentImage || '';
    formValue.notificationId = formValue._id || '';
    formValue.typeId = formValue.type === 'product' ? productId?._id : '';
    formValue.users = formValue.targetUser === 'specific' ? selectedUserData.map((item) => {
      return item?._id
    }) : [];
    console.log("Form Data:", formValue);
    // return false
    const response = await postRequest("notification/update", formValue);
    if (response.status) {
      // setLoading(true);
      toast.success(response.message);
      setLoading(false);
      setTimeout(() => {
        history.goBack('/notifications')
      }, 1000);
    } else {
      setLoading(false);
      toast.error(response.message);
    }
  };

  const closeModal = () => {
    setUserModel(false);
    setModel(false);
  };

  const handleReturnCheck = (selectedUserData) => {
    setUserModel(true);
    setUserReturnChecked(selectedUserData)
  };

  const handleProductCheck = () => {
    setModel(true);
  };

  console.log(productId);
  useEffect(() => {
    if (formValues?.type === 'product' && !productId && !viewMode) {
      setModel(true);
    }
  }, [formValues?.type])

  useEffect(() => {
    if (formValues?.targetUser === 'specific' && !selectedUserData.length && !viewMode) {
      setUserModel(true);
    }
  }, [formValues?.targetUser])

  const selectRow = (item) => {
    setProductId(item);
    console.log(item);
    setModel(false);
  };

  const selectRow2 = (item) => {
    setSelectedUserData(item);
    setUserModel(false);
  };

  let history = useHistory();

  return (
    <React.Fragment>
      <ToastContainer />

      <div className="row">
        <div className="col-lg-10">
          <div className="page-title-box">
            <h4>Notification Management</h4>
            <ol className="breadcrumb m-0">
              <li className="breadcrumb-item active">Notification Management</li>:{" "}
              <li className="breadcrumb-item">{viewMode ? 'View' : 'Create'} Notification</li>
            </ol>
          </div>
        </div>
        <div class="col-md-2 text-end">
          <button
            type="button"
            onClick={() => history.goBack()}
            className="btn btn-primary btn-lg"
          >
            <i class="fas fa-chevron-left"></i> Back
          </button>
        </div>
      </div>
      <Row>
        <Col lg={12}>
          <Card>
            {loading ? (
              <CardBody style={{ height: "100px" }}>
                <Spinner
                  color="info"
                  style={{
                    height: "4rem",
                    width: "4rem",
                    position: "absolute",
                    left: "50%",
                  }}
                >
                  Loading...
                </Spinner>
              </CardBody>
            ) : (
              <CardBody>
                <h4 className="card-title"> {viewMode ? 'View' : 'Create'} Notification</h4>
                <Form onSubmit={handleSubmit}>
                  <Row>
                    <Col lg={12} className="ms-lg-auto">
                      <div className="mt-5 mt-lg-4">
                        {/* First Name */}
                        <div className="row mb-4">
                          <label className="col-sm-3 col-form-label">Title</label>
                          <div className="col-sm-6">
                            <input
                              type="text"
                              disabled={viewMode}
                              onChange={(e) => handleChange("title", e.target.value)}
                              value={formValues.title}
                              name="title"
                              className="form-control"
                            />
                          </div>
                        </div>

                        {/* Last Name */}
                        <div className="row mb-4">
                          <label className="col-sm-3 col-form-label">Description</label>
                          <div className="col-sm-6">
                            <textarea
                              disabled={viewMode}
                              rows={5}
                              className="form-control"
                              onChange={(e) => handleChange("description", e.target.value)}
                              value={formValues.description}
                            >  </textarea>

                          </div>
                        </div>

                        {/* Image */}
                        <div className="row mb-4">
                          <label className="col-sm-3 col-form-label">Image</label>
                          <div className="col-sm-6">
                          {veriFiedDocument?.[0]?.previewUrl ? 
                          <img src={veriFiedDocument?.[0]?.previewUrl} alt="Preview" style={{width : '150px'}} className="mb-2" /> :  
                          <img src={formValues?.image} style={{width : '150px'}} className="mb-2" /> }
                            <input
                              type="file"
                              disabled={viewMode}
                              onChange={(e) => {
                                const file = e.target.files[0];
                                if (file) {
                                  updateDocument("doc", file);
                                }
                              }}
                              name="image"
                              className="form-control"
                            />
                          </div>
                        </div>




                        {/* scheduled */}
                        <div className="row mb-4">
                          <label className="col-sm-3 col-form-label">Scheduled</label>
                          <div className="col-sm-6">
                            <select
                              className="form-control"
                              name="scheduled"
                              disabled={viewMode}
                              onChange={(e) => handleChange("scheduled", e.target.value)}
                              value={formValues.scheduled}
                            >
                              <option value="" disabled>Select Scheduled</option>
                              <option value={true}>Yes</option>
                              <option value={false}>No</option>
                            </select>
                          </div>
                        </div>


                        {/* date */}
                        
                        {String(formValues.scheduled) === "true" && <>
                          <div className="row mb-4">
                            <label className="col-sm-3 col-form-label">Date</label>
                            <div className="col-sm-6">
                              <input
                                type="date"
                                disabled={viewMode}
                                onChange={(e) => handleChange("date", e.target.value)}
                                value={formValues.date}
                                name="date"
                                className="form-control"
                              />
                            </div>
                          </div>

                          <div className="row mb-4">
                            <label className="col-sm-3 col-form-label">Time</label>
                            <div className="col-sm-6">
                              <input
                                type="time"
                                disabled={viewMode}
                                onChange={(e) => handleChange("time", e.target.value)}
                                value={formValues.time}
                                name="time"
                                className="form-control"
                              />
                            </div>
                          </div> </>}


                        {/* Type */}
                        <div className="row mb-4">
                          <label className="col-sm-3 col-form-label">Type</label>
                          <div className="col-sm-6">
                            <select
                              className="form-control"
                              name="type"
                              disabled={viewMode}
                              onChange={(e) => handleChange("type", e.target.value)}
                              value={formValues.type}
                            >
                              <option value="" disabledx>Please select..</option>
                              <option value="product">Product</option>
                              <option value="cart">Cart</option>
                              <option value="order">Order</option>
                              <option value="wishlist">Wishlist</option>
                            </select>
                          </div>
                        </div>
                        {formValues.type ==='product' && 
                        <div className="row mb-4">
                          <label className="col-sm-3 col-form-label"></label>
                          <div className="col-sm-6">
                            
                            {productId && formValues.type ==='product' && <div style={{display : 'flex', gap : '15px'}}>
                               <div>
                               <img src={productId?.images?.[0]} width='200px' className="d-block mb-2" />
                               {!viewMode && 
                               <button type="button" className="btn btn-danger" onClick={() => handleProductCheck()}>
                                Change Product</button> }
                               </div>
                              <h5>{productId?.name}</h5>
                              
                            </div>}
                          </div>
                        </div>
                        }

                        <div className="row mb-4">
                          <label className="col-sm-3 col-form-label">TargetUser</label>
                          <div className="col-sm-6">
                            <select
                              className="form-control"
                              name="targetUser"
                              disabled={viewMode}
                              onChange={(e) => handleChange("targetUser", e.target.value)}
                              value={formValues.targetUser}
                            >
                              <option value="" disabledx>Please select..</option>
                              <option value="all">All</option>
                              <option value="specific">Specific</option>
                            </select>
                          </div>
                        </div>

                        {formValues?.type === 'product' &&
                          <h1>
                            <ProductModal
                              show={model}
                              isActive={true}
                              closeModal={closeModal}
                              selectRow={selectRow} />
                          </h1>
                        }
                      

                        {formValues?.targetUser === 'specific' &&
                          <h1>
                            <UserListModal
                              dataChecked={userReturnChecked}
                              show={usermodel}
                              isActive={true}
                              closeModal={closeModal}
                              selectRow2={selectRow2} />
                          </h1>
                        }

                        {selectedUserData?.length > 0 && formValues?.targetUser === 'specific' &&
                          <div className="col-lg-12 text-end col">
                            <div className="react-bootstrap-table" style={{ overflow: 'auto' }}>
                            {!viewMode &&
                             <button type="button" className="btn btn-danger" onClick={() => handleReturnCheck(selectedUserData)}>
                              <i className="fal fa-plus  fs-5" ></i> Add More</button> }
                              <table className="table table-bordered table-striped">
                                <thead>
                                  <tr>
                                    <th tabIndex={0}>S.NO</th>
                                    <th tabIndex={0}>User Images</th>
                                    <th tabIndex={0}>User Name</th>
                                    <th tabIndex={0}>Email Id</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {selectedUserData?.map((item, index) => {
                                    return (
                                      <tr>
                                        <td>{index + 1}</td>
                                        <td>
                                          <img
                                            src={item?.photo}
                                            alt="img"
                                            width="50px"
                                          />
                                        </td>
                                        <td>{item?.first_name}&nbsp;{item?.last_name}</td>
                                        <td>{item?.email}</td>
                                      </tr>

                                    )
                                  })}
                                </tbody>
                              </table>
                            </div>
                          </div>}



                        {/* Submit Button */}
                        {!viewMode && 
                        <div className="mt-5 mt-lg-4">
                          <div className="row justify-content-end">
                            <div className="col-sm-9">
                              <div>
                                <button type="submit" className="btn btn-primary w-md">
                                  Submit
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        }
                      </div>
                    </Col>
                  </Row>
                </Form>
              </CardBody>
            )}
          </Card>
        </Col>
      </Row>
      {openLightbox && (
        <Lightbox
          mainSrc={previewImage}
          onCloseRequest={() => setOpenLightBox(false)}
        />
      )}

    </React.Fragment>
  );
}
